import React from "react";
import PageRenderer from "../components/PageRender";

const PrivacyPolicy = () => {
  return <PageRenderer pageIdentifier="privacy-policy" />;
};

export default PrivacyPolicy;
